import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { UserService } from 'src/app/services/user/user.service';
import { DataSharingService } from 'src/app/auth/data-sharing.service';
import { VendordashboardService } from 'src/app/services/dashboard/vendor/vendordashboard.service';
import { Vendordata } from 'src/app/model/vendordata.model';
import { isNullOrUndefined } from 'util';
import { isNull } from '@angular/compiler/src/output/output_ast';
import { Observable } from 'rxjs'
import { BehaviorSubject } from 'rxjs';
import { EnlistmentService } from 'src/app/services/enlistment/enlistment.service';
import { Prevendor } from 'src/app/model/prevendor.model';
import { NgForm, FormsModule } from '@angular/forms';
import { ElementRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { distinctUntilChanged } from 'rxjs/operators';
import { Binary } from '@angular/compiler';
import { ReplaySubject } from 'rxjs';
import { Smgmanufacturer } from 'src/app/model/smgmanufacturer.model';

@Component({
  selector: 'app-smgmanufacturer',
  templateUrl: './smgmanufacturer.component.html',
  styleUrls: ['./smgmanufacturer.component.css']
})
export class SmgmanufacturerComponent implements OnInit {

  currentUserData: any;
  vendorData: any;
  vModelData: Vendordata;

  smgmanufacturer: Smgmanufacturer;

  stepno: string;
  returnData : any;

  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService, private vendorDashboardService: VendordashboardService,
    private enlistmentServices: EnlistmentService, private route: ActivatedRoute) {
    this.vModelData = new Vendordata();
    this.smgmanufacturer = new Smgmanufacturer();

    this.stepno = this.route.snapshot.params.stepno;

  }

  ngAfterViewInit() {}

  ngOnInit() {

    
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
        if (this.currentUserData != null) {
          var currentUserId = this.currentUserData.id;
          
          this.vendorDashboardService.getVendorData(currentUserId).subscribe(
            (data) => {
              this.vendorData = data;
              this.vModelData = this.vendorData;

              var enlistData = {
                stepNo : this.stepno,
                applicationNumber : this.vModelData.applicationNumber
              }

              this.enlistmentServices.getEnlistmentFormsSsgSmg(enlistData).subscribe(
                (data) => {
                  this.returnData = data;
                  if(this.returnData.type=="smgmanufacturerform")
                  {
                    this.smgmanufacturer = this.returnData.ssgsmg;
                  }
                  //console.log(data);
                }
              )

            }
          )
        }
      }
    );
  
  }

  SubmitEnlistmentForm(form: NgForm) {
    console.log(form.value);
    form.value.stepNo = this.stepno;
    this.enlistmentServices.saveSmgManufacturerData(form.value).subscribe(
      (data) => {
        alert("Successfully Submitted");
      }
    );
  }


}
